import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSave = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 40.84724 40.84985",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "save" }), /* @__PURE__ */ _jsx("path", {
		d: "M20.42362,1.25H34.76381a.32751.32751,0,0,1,.32751.32751v37.6793a.34235.34235,0,0,1-.58443.24208L20.42362,25.41563,6.34036,39.49889a.34235.34235,0,0,1-.58443-.24208V1.57751A.32751.32751,0,0,1,6.08344,1.25Z",
		style: {
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2.5px"
		}
	})]
});
export default SvgSave;
